//
// ResponsiveConstraint.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../BIRDModel";
import "./HorizontalConstraint";
import "./VerticalConstraint";
import "./ResponsiveWidthConstraint";
import "./ResponsiveHeightConstraint";

var ResponsiveConstraint = createModule("BIRD::ResponsiveConstraint", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        heightConstraint: 1,
        widthConstraint: 1,
        horizontalConstraint: 1,
        verticalConstraint: 1,
        zIndex: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default ResponsiveConstraint;
